export const IMMIGRATE_CATEGORY_REMOVE_REQUEST = 'immigrate-category/remove-request'
export const IMMIGRATE_CATEGORY_REMOVE_SUCCESS = 'immigrate-category/remove-success'
export const IMMIGRATE_CATEGORY_REMOVE_FAILED = 'immigrate-category/remove-failed'
